import { type MessageThread } from '../../../common/validations/residentMessageTimelineSchema'

import { useAPIGetResidentMessageTimeline } from 'api/apiHooks/useAPIGetResidentMessageTimeline'

export const MessagesViewDataLoader = ({
  children,
}: {
  children: (messages: MessageThread[]) => React.ReactNode
}) => {
  const { data } = useAPIGetResidentMessageTimeline()
  return children(
    (data?.messages ?? []).map((thread) => ({
      ...thread,
      entries: thread.entries.map((entry) =>
        entry.__typename === 'OutgoingEmailMessage'
          ? {
              ...entry,
              files: [],
            }
          : entry.__typename === 'IncomingEmailMessage'
            ? {
                ...entry,
                files: [],
              }
            : entry.__typename === 'ManualEmailConversation'
              ? {
                  ...entry,
                  files: [],
                }
              : entry
      ),
    }))
  )
}
